<template>
    <div>
        <div @click="getOtsUrl" id="goHistory">跳转中</div>
    </div>
</template>
<script>
import { goOtsAdminHome } from '@/http/modules/baseSet/ots'
export default {
    name: 'ots',
    data () {
        return {
            fromRouter: ''
        }
    },
    created () {
        this.getOtsUrl()
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
           vm.fromRouter = from.name
        })
    },
    methods: {
        async getOtsUrl () {
            const { data } = await goOtsAdminHome({action: 'getTestPaperManage'})
            window.open(data)
            this.$router.replace({
                name: this.fromRouter
            }, () => {
                window.location.reload()
            })
        },
    }
}
</script>
<style scoped>
</style>